var $grid;
//var elementCounter;
var filterYear = "";
var filterLink = "";
var filterType = "";
var initShow = 2; //number of items loaded on init & onclick load more button
var counter = initShow; //counter for load more button
var iso; // get Isotope instance

var filterOr = [];

$(function() {

	if ($('.filter-list').length == 0) {
		return;
	}

	//elementCounter = $('.filter-counter');

	$grid = $('.filter-list').isotope({
		// options
		itemSelector: '.filter-item',
		layoutMode: 'vertical',
		transitionDuration: '0.3s'
	});

	if ($grid.attr('data-numberofelements').length > 0) {
		initShow = $grid.data('numberofelements');
	}

	$grid.imagesLoaded().progress( function() {
		$grid.isotope('layout');
	});

	iso = $grid.data('isotope');

	// loadmorebutton
	loadMoreBtn(initShow); 

	$('a[data-filter]').on('click', function(event) {
		event.preventDefault();
		
		filterLink = "." + $(this).attr('data-filter');
		$('a[data-filter]').removeClass('active');
		$(this).addClass('active');
		
		filter();
		
		$(this).data('clicked', true);
		loadMoreBtn(initShow);
	});

	$('.filter-year').on('change', function(event) {
		filterYear = "." + $(this).val();
		filter();
	});

	$('input[data-filter]').on('change', function(event) {
		if ($(this).is(':checked')) {
			filterOr.push("." + $(this).attr('data-filter'));
		} else {
			filterOr.splice(filterOr.indexOf("." + $(this).attr('data-filter')),1);
		}

		filterType = filterOr.join('');
		filter();
	});

	$('.filter-reset').on('click', function(event) {
		event.preventDefault();
		resetFilter();
	});

	/*$grid.on( 'arrangeComplete layoutComplete', function( event, filteredItems ) {
		if (elementCounter.length) {
			elementCounter.find('span').html(filteredItems.length);
		}
	});*/

	//when load more button clicked
	$(".filter-load-more").click(function() {
		if ($('a[data-filter]').data('clicked')) {
			//when filter button clicked, set initial value for counter
			counter = initShow;
			$('a[data-filter]').data('clicked', false);
		} else {
			counter = counter;
		};

		counter = counter + initShow;

		loadMoreBtn(counter);
	});
});


function filter() {
	//console.log(filterYear + filterLink + filterType);
	$grid.isotope({ filter: filterYear + filterLink + filterType });

	$(window).trigger('filtered');
};


function resetFilter() {
	filterYear = "";
	filterLink = "";
	filterType = "";

	filter();

	$('.filter-tab-content').hide();
	$('a[data-filter]').removeClass('active');
};

function loadMoreBtn(toShow) {
	$grid.find(".hidden").removeClass("hidden");

	var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
		return item.element;
	});

	$(hiddenElems).addClass('hidden');
	$grid.isotope('layout');

	//when no more to load, hide show more button
	if (hiddenElems.length == 0) {
		$(".filter-load-more").hide();
	} else {
		$(".filter-load-more").show();
	};

}


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/filter/filter.js
 **/